// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"b6c01cda","124":"39c9fa93","327":"0d3fbab4","453":"43249ba8","457":"6604789f","585":"1769e81e","676":"5fae49ff","766":"5dd6de22","786":"8d15e810"}[chunkId] + ".chunk.js";
};